import React from 'react';
import ReactDOM from 'react-dom';
import 'core-js';
import 'core-js/es';
import 'promise-polyfill/src/polyfill';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';
import * as serviceWorker from './serviceWorker';


ReactDOM.render(
    <App/>,
    document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
